import React from "react";

const TestimonialCard = ({
  quote,
  name,
  role,
  image,
  linkedin,
  showReadMore,
  onReadMore
}) => {
  // fallback image if photo is missing
  const avatar = image && image !== "" ? image : "/avatar-placeholder.png";

  return (
    <div
      className="card"
      style={{
        height: "600px",          // your chosen height
        display: "flex",
        flexDirection: "column"
      }}
    >
      {/* Review text */}
      <div>
        <p
          className="text-base"
          style={{
            fontStyle: "italic",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 15,   // your chosen clamp
            WebkitBoxOrient: "vertical"
          }}
        >
          “{quote}”
        </p>

        {/* Read more INSIDE card, right after visible text */}
        {showReadMore && (
          <button
            onClick={onReadMore}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              marginTop: "6px",
              color: "var(--secondary)",
              cursor: "pointer",
              fontSize: "0.9rem"
            }}
          >
            Read complete
          </button>
        )}
      </div>

      {/* Footer pinned to bottom */}
      <div
        className="flex items-center justify-between"
        style={{ marginTop: "auto" }}
      >
        <div className="flex items-center gap-md">
          {image && (
  <img
    src={image}
    alt={name}
    style={{
      width: "44px",
      height: "44px",
      borderRadius: "50%",
      objectFit: "cover"
    }}
  />
)}


          <div>
            <p style={{ fontWeight: 600 }}>{name}</p>
            <p className="text-sm" style={{ color: "var(--text-secondary)" }}>
              {role}
            </p>
          </div>
        </div>

        {linkedin && (
          <a
            href={linkedin}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "var(--secondary)" }}
          >
            in
          </a>
        )}
      </div>
    </div>
  );
};

export default TestimonialCard;
